export default "__VITE_ASSET__tqMXw0Kr__"